import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AccessManagementService } from 'src/app/core/services/access-management.service';
import { SettingsService } from 'src/app/core/services/settings.service';

@Component({
  selector: 'app-discount-form',
  templateUrl: './discount-form.component.html',
  styleUrls: ['./discount-form.component.scss']
})
export class DiscountFormComponent {

  @Input() discountId: any;

  isLoading = false;
  isStaffLoading = false;
  isSubmitting = false;

  sourceOptions = ['stp-web', 'aerticket'];
  staffList: any = [];

  discountData: any = {
    discount_name: '',
    discount_type: '',
    discount: null,
    discount_source: [],
    applicable_staff: [],
    cap_amount: 0,
    valid_from: null,
    valid_to: null,
    is_active: true,
  };

  constructor(private api: SettingsService,
    private accessApi: AccessManagementService,
    public activeModal: NgbActiveModal,
    public toastr: ToastrService) { }

  ngOnInit(): void {
    this.getStaffList();
    if (this.discountId) this.getDiscount();
  }

  getStaffList() {
    this.isStaffLoading = true;
    this.accessApi.getUserAgetList().subscribe(
      (result: any) => {
        this.isStaffLoading = false;
        this.staffList = (result?.results || result || []).filter((user: any) => user?.value);
      },
      () => {
        this.isStaffLoading = false;
        this.toastr.error("Could not load staff list.");
      }
    )
  }

  getDiscount() {
    this.isLoading = true;
    this.api.getDiscountById(this.discountId).subscribe(
      (result: any) => {
        this.isLoading = false;
        this.discountData = result;
      },
      () => {
        this.isLoading = false;
        this.toastr.error("Try Again!", "Something went wrong.");
      }
    )
  }

  staffSearch = (term: string, item: any) => {
    term = (term || '').toLowerCase();
    return `${item?.key || ''}`.toLowerCase().includes(term)
      || `${item?.value || ''}`.includes(term);
  }

  onTypeChange() {
    if (this.discountData.discount_type != 'percentage') this.discountData.cap_amount = 0;
  }

  saveDiscount(form: any) {
    if (form.invalid) {
      form.control.markAllAsTouched();
      return;
    }
    if (this.discountData.valid_from && this.discountData.valid_to
      && this.discountData.valid_to < this.discountData.valid_from) {
      this.toastr.warning("Valid To must be after Valid From.");
      return;
    }
    this.isSubmitting = true;

    const data = {
      discount_name: this.discountData.discount_name,
      discount_type: this.discountData.discount_type,
      discount: this.discountData.discount,
      discount_source: this.discountData.discount_source,
      applicable_staff: this.discountData.applicable_staff,
      cap_amount: this.discountData.discount_type == 'percentage' ? this.discountData.cap_amount : 0,
      valid_from: this.discountData.valid_from || null,
      valid_to: this.discountData.valid_to || null,
      is_active: this.discountData.is_active,
    };

    const request = this.discountId
      ? this.api.updateDiscount(this.discountId, data)
      : this.api.createDiscount(data);

    request.subscribe(
      () => {
        this.isSubmitting = false;
        this.toastr.success(this.discountId ? "Discount updated." : "Discount added.");
        this.closeModal(true);
      },
      () => {
        this.isSubmitting = false;
        this.toastr.error("Try Again!", "Something went wrong.");
      }
    )
  }

  closeModal(status) {
    this.activeModal.close(status);
  }

}
